export default __webpack_public_path__ + "static/media/52t.912ef7a1.jpg";